import React from 'react';

export default function ScenarioCard({ scenario, onClick, disabled = false }) {
  return (
    <div
      onClick={disabled ? undefined : onClick}
      style={{
        background: 'white',
        borderRadius: 'var(--radius-xl, 1rem)',
        padding: '1.25rem',
        cursor: disabled ? 'default' : 'pointer',
        boxShadow: 'var(--shadow-md)',
        transition: 'transform var(--transition-normal), box-shadow var(--transition-normal), opacity var(--transition-normal)',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.75rem',
        position: 'relative',
        overflow: 'hidden',
        opacity: disabled ? 0.6 : 1,
        filter: disabled ? 'grayscale(30%)' : 'none',
      }}
      onMouseOver={(e) => {
        if (!disabled) {
          e.currentTarget.style.transform = 'translateY(-3px)';
          e.currentTarget.style.boxShadow = '0 12px 30px rgba(0,0,0,0.18)';
        }
      }}
      onMouseOut={(e) => {
        if (!disabled) {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '';
        }
      }}
      onTouchStart={(e) => {
        if (!disabled) e.currentTarget.style.transform = 'scale(0.97)';
      }}
      onTouchEnd={(e) => {
        if (!disabled) e.currentTarget.style.transform = 'scale(1)';
      }}
    >
      {/* Top gradient accent bar */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '3px',
        background: `linear-gradient(90deg, ${scenario.color}, ${scenario.color}88)`,
      }} />

      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}>
        <div style={{ fontSize: '2rem' }}>{scenario.icon}</div>
        <span style={{
          fontSize: '1.2rem',
          color: '#ccc',
          transition: 'transform var(--transition-fast)',
        }}>
          &#x203A;
        </span>
      </div>
      <div>
        <h3 style={{
          margin: 0,
          fontSize: '1.05rem',
          color: 'var(--color-text, #333)',
          fontWeight: 700,
        }}>
          {scenario.name}
        </h3>
        <p style={{
          margin: '0.25rem 0 0',
          fontSize: 'var(--font-size-sm, 0.85rem)',
          color: 'var(--color-text-muted, #999)',
          lineHeight: 1.4,
        }}>
          {scenario.description}
        </p>
      </div>
    </div>
  );
}
